import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "288",
  "slug": "spot-spain-from-satellite-imagery",
  "title": "How to Recognise Spain in Satellite Images",
  "excerpt": "Mainland Spain includes a broad interior plateau, the Pyrenees in the northeast, and several other mountain belts.",
  "date": "2026-05-07",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/spain.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Mainland Spain includes a broad interior plateau, the Pyrenees in the northeast, and several other mountain belts. The Ebro basin lies south of the Pyrenees, while the Guadalquivir lowlands occupy part of the southwest. Coastal landscapes vary between the Atlantic and Mediterranean sides."
    },
    {
      "type": "heading",
      "text": "The Meseta and the coastal margins"
    },
    {
      "type": "paragraph",
      "text": "Compare the Ebro basin with the Guadalquivir lowlands. This overview covers mainland Spain and nearby islands, rather than the Canary Islands."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Portugal shares the western Iberian landscape, and olive-growing areas also occur around the Mediterranean. A grid of trees cannot establish Spain. Match the surrounding relief or a river basin first."
    }
  ],
  "imageAlt": "Spain regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
